// Apple Wallet "last step" (founder, 1.5.1 #9): right after a NEW talent's
// Face ID + notifications asks, the app opens their QR page on a full-screen
// "put your QR in Apple Wallet" step. New sign-ups only — existing talent
// never see it: the flag is set on THIS device when the account is created
// (Step6Complete) and spent the first time the moment fires (WalletMoment).

const KEY = "rq_wallet_moment";

/** Fired by AuthContext once the sign-in notification ask is over. */
export const WALLET_MOMENT_EVENT = "rq:push-asked";

export function markNewSignupForWallet(): void {
  try {
    localStorage.setItem(KEY, "pending");
  } catch {}
}

/** A sign-up on this device is still waiting for its Wallet step. */
export function walletMomentPending(): boolean {
  try {
    return localStorage.getItem(KEY) === "pending";
  } catch {
    return false;
  }
}

/** True exactly once after a sign-up on this device; clears the flag. */
export function takeWalletMoment(): boolean {
  try {
    if (localStorage.getItem(KEY) !== "pending") return false;
    localStorage.removeItem(KEY);
    return true;
  } catch {
    return false;
  }
}
